import createBrowserHistory from 'history/createBrowserHistory'
import createHashHistory from 'history/createHashHistory'

// Use hash history for staging branches - if path begins with /branch, otherwise use browser history
const useHashHistory = window.location.pathname.match(/^\/branch\//) || process.env.REACT_APP_USE_HASH_HISTORY
const createSelectedHistory = useHashHistory ? createHashHistory : createBrowserHistory
const history = createSelectedHistory()

export default history



// WEBPACK FOOTER //
// ./src/redux/history.js